// Sveriges bästa ansökningsmall (AI-optimerad) – 10 fasta sektioner
export const ANSOKAN_SECTIONS = [
  {
    key: "beskrivning",
    title: "1. Beskrivning av åtgärden",
    help: "Beskriv exakt vad du vill göra: byggnadstyp, omfattning, material, färg, placering och syfte. Ange om det är nybyggnad, tillbyggnad, ändring, rivning, markåtgärd, skylt eller installation, och om fasad, tak, planlösning eller funktion påverkas.",
  },
  {
    key: "matt",
    title: "2. Mått och tekniska uppgifter",
    help: "Ange byggnadsarea, bruttoarea, höjd, takvinkel, antal våningar, avstånd till tomtgräns och volymförändringar. Ange tydligt om bärande konstruktion, ventilation, VA-system eller eldstad påverkas.",
  },
  {
    key: "placering",
    title: "3. Placering på tomten",
    help: "Var ska åtgärden utföras? Avstånd till tomtgräns, gator, byggnader och viktiga punkter. Ange gärna koordinater eller markering på situationsplan, samt om åtgärden ligger på prickmark, inom byggnadsrätt eller i område med särskilda bestämmelser.",
  },
  {
    key: "handlingar",
    title: "4. Handlingar som bifogas",
    help: "Lista alla handlingar: situationsplan, fasadritningar, planritningar, sektionsritningar, foton, kontrollplan, teknisk beskrivning, konstruktionsritningar, grannyttrande. Ange tydligt om någon handling saknas och varför.",
  },
  {
    key: "fastighet",
    title: "5. Fastighetsinformation",
    help: "Fastighetsbeteckning, adress samt info om detaljplan, kulturmiljö, riksintresse eller tidigare bygglov. Ange om åtgärden avviker från detaljplanen.",
  },
  {
    key: "material",
    title: "6. Material och utformning",
    help: "Fasadmaterial, takmaterial, färg, fönster, dörrar och andra visuella detaljer. Ska byggnaden harmonisera med befintlig miljö eller avvika från omgivningen?",
  },
  {
    key: "installationer",
    title: "7. Installationer och tekniska system",
    help: "Berör åtgärden ventilation, eldstad, VA-system, bärande konstruktion, brandkrav eller tillgänglighet? Beskriv tekniska lösningar och om kontrollansvarig behövs.",
  },
  {
    key: "syfte",
    title: "8. Syfte med åtgärden",
    help: "Varför utförs åtgärden? Mer boyta, förbättrad funktion, ändrat utseende, komplementbyggnad eller teknisk installation?",
  },
  {
    key: "avvikelser",
    title: "9. Eventuella avvikelser",
    help: "Avviker åtgärden från detaljplan, byggnadsarea, höjd, placering eller andra bestämmelser? Har du pratat med grannar eller finns grannyttrande?",
  },
  {
    key: "ovrigt",
    title: "10. Övrig information",
    help: "Allt annat relevant: kulturmiljö, buller, skuggning, insyn, markförhållanden, dagvatten, trafiksäkerhet eller särskilda omständigheter/regler i området.",
  },
];
